import clsx from "clsx";
import { PropsWithChildren } from "react";
import styles from "./styles.module.scss";

interface IconButtonProps
  extends PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement>> {
  className?: string;
  testID?: string;
}

const IconButton = (props: IconButtonProps) => {
  return (
    <button
      {...(props as any)}
      className={clsx(props.className, styles.button)}
      type="button"
      data-testid={props.testID}
    >
      {props.children}
    </button>
  );
};

export default IconButton;
